import { createAction } from '@reduxjs/toolkit';

const addToDeleted = createAction('archive/addToDeleted');

export default addToDeleted;
